export const mappingData = {
  text: "Mapping Sales Data",
  subtext:
    "It may take a while to map all data, depending on the data volume. You may close this window, the map process will keep running in the background.",
};
export const mappedData = {
  text: "Sales Data Mapping Complete",
  subtext: "Sales records mapped and added to sales record list",
};
export const failedMappedData = {
  text: "Failed to Map Sales Data",
  subtext: "",
};

export const processingData = {
  text: "Processing Sales Data",
  subtext:
    "It may take a while to process all data, depending on the data volume. You may close this window, the process will keep running in the background. You will be notified when the process is complete.",
};
